import { h, Component } from 'preact'
import axios from 'axios'
import Phrase from '../../libs/translationsUtils/phrase'
import ContentCurationItem from '../content-curation/ContentCurationItem'
import { CuratedTopic } from '../content-curation/HomepageContentCurationManager'
import QuestionIcon from '../assets/icon-content-type-question'
import ArticleIcon from '../assets/icon-content-type-article'
import AnswerIcon from '../assets/icon-content-type-answer'
import DiscussionIcon from '../assets/icon-content-type-discussion'
import IdeaIcon from '../assets/icon-content-type-idea'

interface Props {
  eventId: number
}

interface State {
  topics: CuratedTopicWithIconAndIdx[],
  error: boolean
}

interface CuratedTopicWithIconAndIdx extends CuratedTopic {
  icon?: JSX.Element,
  idx?: number
}

class FeaturedTopicsListAsRecommended extends Component<Props, State> {

  constructor (props: Props) {
    super(props)
    this.state = {
      topics: [],
      error: false
    }
  }

  async componentDidMount () {
    await this.loadTopics();
  }

  private async loadTopics() {
    this.setState({ error: false })
    try {
      const res = await axios.get(`/events/${this.props.eventId}/featuredTopics`, {
        params: { as:  'recommended' }
      })
      this.setState({ topics: res.data })
    } catch (err) {
      this.setState({ error: true })
    }
  }

  render ({ eventId }: Props, { error, topics }: State) {
    if (topics.length === 0) return null

    const topicType = {
      'question': <QuestionIcon width={13.33} height={13.33} withoutBorder />,
      'article': <ArticleIcon width={13.33} height={13.33} withoutBorder />,
      'answer': <AnswerIcon width={13.33} height={13.33} withoutBorder />,
      'discussion': <DiscussionIcon width={13.33} height={13.33} withoutBorder />,
      'idea': <IdeaIcon width={13.33} height={13.33} withoutBorder />
    }

    return <div class='event-featured-topics-as-recommended'>
      <div class='event-featured-topics-as-recommended__header-label'><Phrase p='events.featured.topics' /></div>
      <ul class='event-featured-topics-as-recommended__topics-list'>
        { topics.map((item: CuratedTopicWithIconAndIdx, idx) => {
          item.icon = topicType[item.type]
          item.idx = idx
          return <ContentCurationItem {...item} />
        })}
      </ul>
    </div>
  }
}

export default FeaturedTopicsListAsRecommended
